import { rem } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

import Button from "components/Button";

export const Container = styled.div`
  margin-bottom: 24px;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  ${media.greaterThan("huge")`
    margin-bottom: 32px;
  `}
`;

export const Head = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  font-size: ${rem("9px")};
  color: ${themes.text.medium};

  ${media.greaterThan("large")`
    font-size: ${rem("13px")};
  `}

  ${media.greaterThan("huge")`
    font-size: ${rem("14px")};
  `}
`;

export const Right = styled.div`
  padding-left: 32px;
`;

export const Action = styled(Button)<any>`
  &:not(:last-of-type) {
    margin-right: 16px;
  }
`;
